import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-event-type-filter',
  templateUrl: './event-type-filter.component.html',
  styleUrls: ['./event-type-filter.component.scss'],
})
export class EventTypeFilterComponent implements OnChanges {
  @Input() eventTypeList = [];
  @Output() filterSelected = new EventEmitter<any>();
  public eventText = '';
  public employeesText = '';
  public filtersData = {
    event: [],
  };

  selectEventType(eventType) {
    const index = this.filtersData.event.indexOf(eventType);
    if (index < 0) {
      this.filtersData.event.push(eventType);
    } else {
      this.filtersData.event.splice(index, 1);
    }
    this.detectingEvents(this.filtersData.event);
    this.emitEvent();
  }

  detectingEvents(events) {
    if (events.length > 0) {
      const names = this.eventTypeList
        .filter((n) => events.includes(n.event))
        .map((e) => this.capitalize(e.event));
      this.eventText = names.join(', ');
    } else {
      this.eventText = '';
    }
  }

  capitalize(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  emitEvent() {
    this.filterSelected.emit(this.filtersData);
  }

  resetFilters() {
    this.filtersData.event = [];
    this.eventText = '';
    this.eventTypeList = this.eventTypeList.map((employee) => ({
      ...employee,
      selected: false,
    }));
    this.emitEvent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventTypeList?.currentValue) {
      this.eventTypeList = changes.eventTypeList.currentValue;
      this.filtersData.event = [];
      this.eventText = '';
    }
  }
}
